<template>
  <template v-if="rows.length > 0">
    <TableRow v-for="(row, rowIndex) in rows" :key="row._id" :config="configTableRow" :row="row" :rowIndex="rowIndex" :id="`item-${row._id}`" :class="`item item-${row._id}`" :data-id="row._id" />
  </template>
  <template v-else-if="!loaded">
    <tr v-for="n in 10" :key="n">
      <td class="column column-no-item">
        <SkeletonLoading></SkeletonLoading>
      </td>
    </tr>
  </template>
  <template v-else>
    <tr>
      <td :colspan="Object.keys(cols).length" class="column column-no-item">
        <span>No item found</span>
      </td>
    </tr>
  </template>
</template>

<script>
import SkeletonLoading from '@/components/SkeletonLoading.vue'
import TableRow from './TableRow.vue'
export default {
  components: {
    SkeletonLoading,
    TableRow
  },
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    cols() {
      return this.config?.cols || {}
    },
    rows() {
      return this.config?.rows || {}
    },
    loaded() {
      return this.config?.loaded || false
    },
    configTableRow() {
      return {
        ...this.config
      }
    }
  },
  methods: {
    //
  },
  props: {
    config: Object
  }
}
</script>
